<template>
  <div
    class="dropdown-menu"
    :class="{'dropdown-menu--active': isActive,'dropdown-menu--gradient': hasGradient, 'dropdown-menu--collapsible': isCollapsible}"
    @click.stop
  >
    <slot />
  </div>
</template>

<script>
  export default {
    props: {
      isCollapsible: {
        type: Boolean,
        default: false
      },
      isActive: {
        type: Boolean,
        default: true
      },
      hasGradient: {
        type: Boolean,
        default: false
      }
    }
  };
</script>
<style lang="scss">
  @import "../../styles/shared/shared";
  .dropdown-menu {
    display: none;
    overflow: auto;
    text-align: left;
    &:not(&--collapsible) {
      position: absolute;
      z-index: $z-dropdown-menu;
      top: 100%;
      left: 0;
      margin-top: 2rem;
      padding: 1rem $dropdown-padding-x;
      max-height: 25rem;
      min-width: 16rem;
      border-radius: .25rem;
      background-color: $white;
      box-shadow: 0 2px 5px 0 rgba(132,157,176,0.22);
    }
    &--gradient {
      background: $gradient;
      color: $white;
      box-shadow: 0 2px 4px 0 rgba(9,33,57,0.2);
      a {
        &,
        &:hover,
        &:focus {
          color: inherit;
        }
      }
      &:after {
        bottom: 100%;
        left: 8px;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
        border: solid transparent;
        border-bottom-color: #0546C7;
        border-width: 12px 16px;
      }
    }
    &--active {
      display: block;
    }
  }
</style>
